export default function isActionSourcePrefetch(actionSource) {
    var prefetchActionSources = [
        'PrefetchFirstN',
        'PrefetchSingleRow',
        'PrefetchRowInCache',
        'PrefetchAjacentItemsOnDelay',
    ];
    return prefetchActionSources.includes(actionSource);
}
//# sourceMappingURL=isActionSourcePrefetch.js.map